// This file is generated by a postinstall script (generate-version-file.js).
export const version = '4.4.1'
export const chameleonCoreVersion = '3.0.2'